import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Assessor.css";
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import withMenuPermission from "../../../widgets/withMenuPermission";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';


const utils = new ViewUtils();

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to assessor approval search', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to qualification scope', theme: true }
            ]
        }
    ]
};

const headCells = [
    { id: 'SAQAQualificationID', numeric: false, disablePadding: true, label: 'Qualification Code' },
    { id: 'SAQAQualificationTitle', numeric: false, disablePadding: true, label: 'Qualification Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'QualificationRegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'QualificationRegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];

class OnlineAssessorApprovalQualificationScope extends Component {

    constructor(props) {
        super(props)

        this.state = {
        }

        this.currentSelection = this.props.location.state.selectedQualificationRows;
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineAssessorApprovalSkillsProgrammeScope',
                state: {
                    selection: this.props.location.state.selection,
                    selectedQualificationRows: this.currentSelection,
                    selectedSkillsProgrammeRows: !utils.isNull(this.props.location.state.selectedSkillsProgrammeRows) ? this.props.location.state.selectedSkillsProgrammeRows : []
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/assessorapproval',
                state: {
                    selection: this.props.location.state.selection,
                    selectedQualificationRows: this.currentSelection,
                    selectedSkillsProgrammeRows: !utils.isNull(this.props.location.state.selectedSkillsProgrammeRows) ? this.props.location.state.selectedSkillsProgrammeRows : []
                }
            });
        }
    }

    handleSelectionChange = (selection) => {

        if (this.currentSelection == this.props.location.state.selectedQualificationRows && selection.length == 0) {
            return
        }

        if (selection !== null && selection.length !== 0) {
            const selectionIds = selection.map(item => item.Id);

            selectionIds.forEach(id => {
                if (!this.currentSelection.includes(id)) {
                    this.currentSelection.push(id);
                }
            });

            this.currentSelection = this.currentSelection.filter(id => selectionIds.includes(id));
        }
        

        if (selection.length == 0 && this.props.location.state.selectedQualificationRows.length > 0) {
                this.currentSelection = [];
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Assessor Approval > Qualification Scope"}
                </p>
                <br></br>
                <EnhancedTable autoFetchData={true} headCells={headCells} searchParameters={[{ Name: `OnlineAssessorAppID`, Value: this.props.location.state.selection }]} paged={false}
                    dataUrl="api/sims/OnlineAssessorApproval/GetQualificationScope" multiSelect={true} onSelectionChange={(selection) => { this.handleSelectionChange(selection) }} preSelectedList={this.props.location.state.selectedQualificationRows}
                />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)} config={lowertoolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(OnlineAssessorApprovalQualificationScope));

